import React from 'react';
import classes from './CredForm.module.css';

const StepComponent = ({ heading = '', steps, isEditScreen = false }) => {
  return (
    <div>
      <h5 className={classes.stepsHeadings}>
        <span>{heading}</span>
      </h5>
      <div
        className={classes.cardMain}
        style={{
          padding: isEditScreen ? '1rem' : '1rem 2rem',
        }}
      >
        <div className={`${classes.flexColumn} ${classes.cardMain}`}>
          <div style={{ display: 'flex', gap: '4rem', justifyContent: 'space-between' }}>
            <div className={classes.flexColumn}>
              {steps.map((step, index) => (
                <div key={index} className={classes.stepsContentFullWidth}>
                  <div className={classes.index}>
                    <div>{index + 1}</div>
                  </div>
                  <div>
                    <p dangerouslySetInnerHTML={{ __html: step.text }}></p>
                    {step.list && (
                      <ul className={classes.listStyle}>
                        {step.list.map((item, idx) => (
                          <li key={idx}>{item}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepComponent;
